import profilePlaceholder from "../assets/profile-placeholder.svg";

/**
 * @param {{ photoDataUrl?: string | null } | null | undefined} user
 * @returns {string}
 */
export function resolveNavProfilePhotoSrc(user) {
  const raw = user?.photoDataUrl;
  if (raw != null && String(raw).trim() !== "") {
    return String(raw).trim();
  }
  return profilePlaceholder;
}

/**
 * Circular nav profile photo (applicant, hiring, public home).
 *
 * @param {{
 *   currentUser?: { photoDataUrl?: string | null } | null,
 *   onClick: () => void,
 *   ariaLabel: string,
 *   className?: string,
 * }} props
 */
export default function NavProfileAvatar({ currentUser, onClick, ariaLabel, className = "" }) {
  const src = resolveNavProfilePhotoSrc(currentUser);
  const extraClass = String(className || "").trim();

  return (
    <button
      type="button"
      className={`avatar avatar-button nav-profile-avatar${extraClass ? ` ${extraClass}` : ""}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <img src={src} alt="" className="avatar-image" />
    </button>
  );
}
